<template>
  <div class="main notMemberEditPayment">
    <!-- 上部分 -->
    <div class="title" style="margin-bottom: 80px;">
      <span class="text">
        上传缴费凭证
        <span>
          (
          <span style="color: #FF0000">*</span>为必填项)
        </span>
      </span>
    </div>

    <!-- 下部分 -->
    <el-form :label-position="labelPosition" label-width="400px">
      <el-form-item label="缴费年份" required>
        <el-date-picker
          v-model="form.year"
          type="year"
          align="left"
          placeholder="请选择年份"
          :picker-options="yearPickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="缴费日期" required>
        <el-date-picker
          v-model="form.paydate"
          type="date"
          align="left"
          placeholder="请选择日期"
          :picker-options="datePickerOptions"
        ></el-date-picker>
      </el-form-item>
      <el-form-item label="缴费金额" required>
        <el-input v-model="form.amount"></el-input>
      </el-form-item>
      <el-form-item label="缴费凭证" required>
        <input type="file" hidden ref="selectFile" @change="handleChange"/>
        <el-button size="medium" type="primary" @click="uploadFile">选择文件</el-button>
        <p>
          <span v-if="!fileUrl">{{fileName}}</span>
          <a v-if="fileUrl" :href="fileUrl" target="_blank">{{fileName}}</a>
        </p>
      </el-form-item>
    </el-form>
    <div class="btn">
      <el-button type="plain" @click="cancel">取消</el-button>
      <el-button type="primary" @click="submit">确定</el-button>
    </div>
  </div>
</template>

<script>
import * as API from '../utils/apiService'
import * as Cache from '../utils/cache'
import { setTimeout } from 'timers'
import moment from 'moment'

export default {
  data () {
    return {
      form: {
        year: '',
        amount: '',
        paydate: '',
        file: {}
      },
      yearPickerOptions: {
        shortcuts: [
          {
            text: '现在',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          }
        ]
      },
      datePickerOptions: {
        shortcuts: [
          {
            text: '现在',
            onClick (picker) {
              picker.$emit('pick', new Date())
            }
          }
        ]
      },
      labelPosition: 'right',
      fileName: '',
      fileUrl: ''
    }
  },
  methods: {
    cancel () {
      this.$router.push('/notMemberPayment')
    },
    uploadFile () {
      this.$refs.selectFile.click()
    },
    // 文件改变时触发
    handleChange (e) {
      this.file = e.target.files[0]
      this.fileName = this.file.name
      this.$refs.selectFile.value = null
      this.fileUrl = this.getFileURL(this.file)
      return e
    },
    // 获取文件路径
    getFileURL (file) {
      let url = null
      if (file) {
        if (window.createObjectURL !== undefined) {
          // basic
          url = window.createObjectURL(file)
        } else if (window.URL !== undefined) {
          // mozilla(firefox)
          url = window.URL.createObjectURL(file)
        } else if (window.webkitURL !== undefined) {
          // webkit or chrome
          url = window.webkitURL.createObjectURL(file)
        }
      }
      return url
    },
    // 点确定时提交表单
    submit () {
      if (!this.form.year) {
        this.$message.error('请选择缴费年份')
        return
      }
      if (!this.form.paydate) {
        this.$message.error('请选择缴费日期')
        return
      }
      if (!this.form.amount) {
        this.$message.error('请填写缴费金额')
        return
      }
      if (!this.file) {
        this.$message.error('请上传缴费凭证')
        return
      }
      let params = {
        userid: Cache.getUserInfo().id
      }
      API.findOneInfo(params).then(resp => {
        if (resp.resultCode === '0000') {
          this.id = resp.data.id
          let _params = {
            file: this.file,
            membershipid: this.id,
            year: moment(this.form.year).format('YYYY'),
            amount: this.form.amount,
            paydate: moment(this.form.paydate).format('YYYY-MM-DD')
          }
          API.addPayment(_params).then(resp => {
            if (resp.resultCode === '0000') {
              this.$message.success(resp.resultMsg)
              setTimeout(() => {
                this.$router.push('/notMemberPayment')
              }, 1000)
            } else {
              this.$message.error(resp.resultMsg)
            }
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.notMemberEditPayment {
  .btn {
    margin-left: 400px;
    margin-top: 70px;
  }
  .el-input {
    width: 220px;
  }
}
</style>
